<template>
  <div id="app-container">
    <div v-show="isLoading">
      <app-loading />
    </div>
    <template v-show="!isLoading">
      <div class="h-max-content" v-if="isNoTemplate && !isDarkModeDashboard"> 
        <RouterView />
      </div>
      <template v-if="isDarkModeDashboard && !isNoTemplate"> 
        <RouterView />
      </template>
      <div v-if="!isNoTemplate && !isDarkModeDashboard">
        <b-container fluid :class="isShowMenubar ? 'container-app-menubar' : ''">
          <b-row class="app-navbar">
            <b-col class="p-0" :cols="12">
              <div>
                <b-navbar fixed="true" class="pr-0 mt-2">
                  <b-row :class="'w-100 ' + (isShowMenubar ? 'container-app-active' : 'container-app-inactive')">
                    <b-col :cols="getContentCols" class="app-content pr-0 offset-2">
                      <div class="app-content-navbar">
                        <span class="left-nav">
                          <button id="sidebarToggleTop" v-on:click="toggleSidebar" class="app-btn-menu app-btn-sm btn mr-0 float-left" v-if="isShowBurgerButton">
                              <b-icon-list></b-icon-list>
                          </button>
                          <span class="logo" @click="backToHome()">
                            <img :src="`${publicPath}/img/maruhide-logo.png`" class="menu-logo" id="menu-logo" alt="menu logo" />
                          </span>
                          <span class="route-name ml-3 d-none d-md-inline-block">
                            Production Control System
                            <Breadcrumbs v-if="false"></Breadcrumbs>
                          </span>
                        </span>
                        <span class="float-right" style="line-height: 3.5;">
                          <b-dropdown class="btn-header-action" size="sm" right>
                            <template #button-content>
                              <b-avatar class="app-avatar"></b-avatar>
                            </template>
                            <b-dropdown-item to="/mydeviceprofile">
                              My Device Profile
                            </b-dropdown-item>
                            <b-dropdown-item to="/myprofile">
                              My Profile
                            </b-dropdown-item>
                            <b-dropdown-item @click="showUserGuide">
                              User Guide
                            </b-dropdown-item>
                            <b-dropdown-item @click="logout">
                              Logout
                            </b-dropdown-item>
                          </b-dropdown>
                        </span>
                        <button class="btn float-right mr-3 d-inline-block" style="padding:0.25rem;padding-bottom:0rem;line-height: 2.8;padding-top:0.5rem !important" v-if="false">
                          <b-icon-bell></b-icon-bell>
                        </button>
                        <button class="btn float-right mr-3 d-sm-none d-md-inline-block" style="padding:0.25rem;padding-bottom:0rem;line-height: 2.8;padding-top:0.5rem !important" v-if="false">
                          <b-icon-gear></b-icon-gear>
                        </button>
                        <b-badge variant="danger" class="float-right d-inline-block mr-3 p-2 app-navbar-user-badge">
                          Greetings, {{ firstName }}
                        </b-badge>
                      </div>
                    </b-col>
                  </b-row>
                </b-navbar>
              </div>
            </b-col>
          </b-row>
          <b-row :class="isShowMenubar ? 'container-app-active' : 'container-app-inactive'">
            <b-col :cols="2" class="app-sidebar">
              <div class="left-nav mt-4 position-fixed">
                <button id="sidebarToggleTop" v-on:click="toggleSidebar" class="app-btn-menu btn float-left">
                    <b-icon-list></b-icon-list>
                </button>
                <PortalTarget name="sidebar-search" :class="!isShowMenubar ? 'd-none' : ''" />
              </div>
              <LeftMenu :class="getSidebarClass + ' container-body'" :isShowSidebar.sync="isShowMenubar" />
              <div v-on:click="isShowMenubar = false" :class="getClassOverlay">
                <b-overlay :show="overlayShown" blur="none" style="width:100%;height:100%" spinner-type="">
                </b-overlay>
              </div>
            </b-col>
            <b-col :cols="getContentCols" class="app-content">
              <b-container fluid :class="isInbox ? 'col-12 container-body-inbox p-0 ml-0 mr-0' : 'col-12 container-body pr-sm-0 pl-sm-0'">
                <PortalTarget name="app-popup" />
                <PortalTarget name="app-popup-detail" />
                <div v-if="!isHome" >
                  <div class="app-breadcrumbs-bar" v-if="false">
                    <Breadcrumbs :showOnMobile="false"></Breadcrumbs>
                    <div class="app-input-search">
                      <b-input-group>
                        <b-form-input
                            id="search-input"
                            type="text"
                            placeholder="Cari"
                            autocomplete="off"
                            size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button size="sm"><b-icon-search /></b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                  <b-card :class="'card-container'" body-class="card-container-body">	
                    <RouterView />	
                  </b-card>	
                </div>	
                <div v-else>	
                  <RouterView />	
                </div>	
              </b-container>
            </b-col>
            <b-col :cols="getSidebarCols" v-if="isShowSidebar" class="pl-0 pr-0" style="border-left: 1px solid rgba(0, 0, 0, 0.1);">
            </b-col>
          </b-row>
        </b-container>
        <div class="navbar-bottom-container p-0 w-100 d-sm-block d-md-none" v-if="!isHome">
        <b-navbar type="dark" class="navbar-bottom" variant="dark" fixed="true">
            <b-col class="col-12 p-0">
              <PortalTarget name="app-navbar-bottom" />
            </b-col>
          </b-navbar>
        </div>
      </div>
    </template>
    <PopupError :openPopup="globalErrorExists" />
    <PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModalPdf" label="User Guide" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import PopupError from '@/components/PopupError'
import PopupPDF from '@/components/PopupPDF'
import LeftMenu from './components/Sidebar'
import AppLoading from './components/AppLoading'
import Role from '@/models/Core/Role'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  title: 'Production Control System',
  components : {
    Breadcrumbs,
    LeftMenu,
    PopupError,
    AppLoading,
    PopupPDF
  },
  methods : {
      async showUserGuide() {
          return;
      this.pdfUrl = '/files/userguide/pdf_for_mhd.pdf';
      await this.$http.get(process.env.VUE_APP_API_URL + `UserInfo/Me`).then(result => {
        if(result.data.vendorId) {
          this.pdfUrl = '/files/userguide/pdf_for_vendor.pdf';
        }
      })

      console.log("pdf url", this.pdfUrl);

      this.isShowPopUpPdf = true
    },
    resetModalPdf() {
      this.pdfUrl = '';
      this.isShowPopUpPdf = false;
    },
    backToHome() {
      this.$router.replace("/");
    },
    toggleSidebar() {
      this.isShowMenubar = !this.isShowMenubar;
    },
    preventBackRouteOnSwiped() {
      var scrolled = false;
      var scrollTimeout;
      window.addEventListener('mousewheel', function(e) {
        if (e.wheelDeltaY === 0) {
          if (!scrolled) {
            scrolled = true;
            scrollTimeout = setTimeout(function(){
              scrolled = false;
            }, 10000);
          }
        }
      });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 1330) {
        this.isShowBottomNavbar = true;
        this.isShowMenubar = false;
      } else {
        this.isShowBottomNavbar = false;
      }

      if (this.windowWidth <= 576) {
        this.isShowBurgerButton = false;
      } else {
        this.isShowBurgerButton = true;
      }
    },
    checkWindowSize() {
      //this.isShowMenubar = false;
    },
    isLoginPage() {
      var menu_name = this.$route.name != null && this.$route.name != undefined  ? this.$route.name : "";
      document.body.classList.remove("body-home");
      document.body.classList.remove("body-inbox");
      document.body.classList.remove("app-login");
      
      document.body.style.overflow = "auto";
      document.body.style.overflowY = "auto";
      document.body.style.overflowX = "hidden";
      this.isDarkModeDashboard = false;
      if (menu_name.toLowerCase() == "login" || menu_name.toLowerCase() == "loadhome") {
        this.isNoTemplate = true;
        if (menu_name.toLowerCase() == "login") {
          document.body.classList.add("app-login");
        }
      } else if (menu_name.indexOf("dashboard") > -1) {
        this.isDarkModeDashboard = true;
      }
       else {
        this.isNoTemplate = false;
        this.isInbox = false;
        this.isHome = false;
        
        document.body.classList.add("body-home");
        if (menu_name == "home" || menu_name == "homeindex" || menu_name == 'homedashboardindex' || menu_name == 'homemobile') {
          this.getUserRole();
          this.isHome = true;
        } else {
          //document.body.classList.remove("body-home");
        }

        if (menu_name.indexOf("inbox") > -1 || menu_name.indexOf("needtoapprove") > -1 || menu_name.indexOf("needrevision") > -1 || (menu_name.indexOf("index") < 0 && menu_name.indexOf("detail") < 0  &&  menu_name.indexOf("create") < 0 && menu_name.indexOf("edit") < 0 && menu_name.indexOf("home") < 0)) {
          this.isInbox = true;
          document.body.classList.add("body-inbox");
          document.body.style.overflow = "hidden";
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        } else {
          document.body.style.overflowY = "auto";
          document.body.style.overflowX = "hidden";
        }
        this.isShowBottomNavbar = false;
        if (menu_name.indexOf("inbox") > -1 || menu_name.indexOf("index") > -1) {
          this.windowWidth = window.innerWidth;
          if (this.windowWidth <= 576) {
            this.isShowBottomNavbar = true;
            this.$forceUpdate();
          }
        }
      }
    },
    async getUserRole() {
      var menu_name = this.$route.name != null && this.$route.name != undefined  ? this.$route.name : "";
      if (menu_name.toLowerCase() != "login") {
        if (this.$store.getters.isLoggedIn == true) {
          if (this.accessToken != null && this.accessToken != undefined && this.accessToken != "") {
            let this_ = this;
            return Role.getMe(this).then(result => {
              this.$store.dispatch('setRoleLoaded');
              this.$store.dispatch('get_userinfo');
            }).catch(function (error) {
              if (error.response) {
                if (error.response.status == 401) {
                  this_.logout();
                } else {
                  this_.$store.dispatch('addErrorMessageGlobal', error);  
                }
              } else {
                this_.$store.dispatch('addErrorMessageGlobal', error);
              }
            });
          }
        }
      }
    },
    async checkLogin() {
      this.isLoading = true;
      let this_ = this;
      return this.$http.get(process.env.VUE_APP_API_URL + `UserInfo/Me`).then(result => {
        this.currentUser = result.data;
        console.log(this.currentUser);
        this_.isLoading = false;
        return true;
      }).catch(function (error) {
        this_.isLoading = false;
        this_.logout();
      });
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.$store.state.successMessageGlobal, {
          title: "Success",
          variant: variant,
          autoHideDelay: '2500',
          solid: true
      });
      this.$store.dispatch('removeSuccessMessageGlobal');
    },
    logout() {
      this.$store.dispatch('logout').then(()=>{
        this.isNoTemplate = true;
        this.$router.replace("/login");
      });
    },
    checkUserAgent() {
      const userAgent = navigator.userAgent;

      let operatingSystem = "";
      if (/Windows/i.test(userAgent)) {
        operatingSystem = "windows";
      } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
        operatingSystem = "maocs";
      } else if (/Linux/i.test(userAgent)) {
        operatingSystem = "linux";
      } else if (/Android/i.test(userAgent)) {
        operatingSystem = "android";
      } else if (/iOS|iPhone|iPad/i.test(userAgent)) {
        operatingSystem = "ios";
      }

      document.body.classList.add("app-" + operatingSystem);

      navigator.userAgentData.getHighEntropyValues(["platformVersion"])
      .then(ua => {
        if (navigator.userAgentData.platform === "Windows") {
          const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
          if (majorPlatformVersion >= 13) {
              document.body.classList.add("app-windows-11");
            }
        }
      });
    },
    handleScroll() {
      let elementAppContent = document.querySelector(".app-content-navbar");
      if (elementAppContent) {
        let elContainer = document.querySelector("#app-container");
        if(elContainer.scrollTop > 20) {
          elementAppContent.classList.add("bottom-shadow"); 
        } else {
          elementAppContent.classList.remove("bottom-shadow"); 
        }
      }
    }
  },
  data() {
    return {
      isShowMenubar: false,
      isNoTemplate: true,	
      isInbox: false,	
      isHome: false,
      isShowBottomNavbar: false,
      contentCols : 9,
      sidebarCols : 3,
      windowWidth: window.innerWidth,
      isLoading: false,
      isDarkModeDashboard: false,
      isShowBurgerButton: true,
      isVendor: false,
      pdfUrl: '',
      isShowPopUpPdf: false,
      currentUser: null,
    }
  },
  beforeMount() {
    this.$store.dispatch('removeSuccessMessageGlobal');
    
  },
  mounted() {
      this.checkLogin().then(result => {
          this.checkWindowSize();
          this.isLoginPage();
          this.preventBackRouteOnSwiped();
          this.onResize();
      })
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
        this.$store.dispatch('unsetRoleLoaded');
        this.checkUserAgent();
        let elContainer = document.querySelector("#app-container");
        console.log(elContainer);
        if (elContainer)
          elContainer.addEventListener("scroll", this.handleScroll, true);
      });
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
    this.$store.dispatch('unsetRoleLoaded');
  },
  computed : {
    isShowSidebar() {
      return this.$store.state.isShowSidebar;
    },
    overlayShown() {
      return this.isShowMenubar;
    },
    globalErrorExists() {
      return this.$store.state.errorMessageGlobal != null && this.$store.state.errorMessageGlobal != "" ? true : false;
    },
    getClassOverlay() {
      if (this.isShowMenubar) {
        return "showOverlay showOverlay-active app-sidebar-overlay";
      }
      return "showOverlay app-sidebar-overlay";
    },
    getSidebarCols() {
      /*if (this.$store.state.isShowSidebar) {
        return 3;
      } else {
        return 0;
      }*/
    },
    getSidebarClass() {
      if (this.isShowMenubar) {
        let cols = "col-2";
        if (this.windowWidth < 1200 && this.windowWidth >= 768) {
          cols = "col-4";
        } else if (this.windowWidth < 768  && this.windowWidth >= 576) {
          cols = "col-6";
        } else if (this.windowWidth < 576) {
          cols = "col-8";
        }
        return "sidebar-active ";
      }
      return "";
    },
    getSidebarCols() {
      if (this.isShowMenubar) {
        if (this.windowWidth < 1200) {
          return 2;
        }
        return 2;
      }
      return 0;
    },
    getContentCols() {
      if (this.isShowMenubar) {
        if (this.windowWidth < 1330) {
          return 12;
        }
        return 10;
      }
      return 12;
    },
    ...mapGetters({
      accessToken: 'accessToken',
      isLoggedIn: 'isLoggedIn',
      user: 'user',
      userName: 'userName',
      firstName: 'firstName'
    }),
    routeName() {
      return this.$route.name;
    }
  },
  watch : {
    '$route'(to, from) {
      if (to != null) {

        if (this.windowWidth < 1200) {
          this.isShowMenubar = false;
        }
        this.isInbox = false;
        this.isDarkModeDashboard = false;

        document.body.classList.remove("body-inbox");
        document.body.style.overflow = "auto";
        document.body.style.overflowY = "auto";
        document.body.style.overflowX = "hidden";

        document.body.classList.remove("app-login");
        if (to.name == "login") {
          this.isNoTemplate = true;
          document.body.classList.remove("body-home");
          document.body.classList.add("app-login");
				} else if (to.name.indexOf("dashboard") > -1) {
          this.isDarkModeDashboard = true;
        }
        else if (to.name.indexOf("needrevision") > -1) {
          this.isDarkModeDashboard = true;
        } else {
          this.isHome = false;
          if (to.name == "loadhome") {
            document.body.classList.remove("body-home");
          } else if (to.name == "home" || to.name == "homeindex" || to.name == 'homedashboardindex' || to.name == 'homemobile') {
            this.isHome = true;
            document.body.classList.add("body-home");
          } else {
            document.body.classList.add("body-home");
          }
          if (to.name.indexOf("inbox") > -1 || to.name.indexOf("needtoapprove") > -1 || to.name.indexOf("needrevision") > -1 || (to.name.indexOf("index") < 0 && to.name.indexOf("home") < 0 && to.name.indexOf("detail") < 0  &&  to.name.indexOf("create") < 0 && to.name.indexOf("edit") < 0 )) {
            this.isInbox = true;
            document.body.classList.add("body-inbox");
            document.body.style.overflow = "hidden";
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          } else {
            document.body.style.overflowY = "auto";
            document.body.style.overflowX = "hidden";
          }
          
          this.isShowBottomNavbar = false;
          if (to.name.indexOf("inbox") > -1 || to.name.indexOf("index") > -1) {
            this.windowWidth = window.innerWidth;
            if (this.windowWidth <= 576) {
              this.isShowBottomNavbar = true;
            }
          }
          
          let appContainer = document.querySelector("#app-container");
          if (appContainer)
            appContainer.scrollTop = 0;

          this.isNoTemplate = false;
          this.$forceUpdate();
        }
			}
		},
    '$store.state.successMessageGlobal' : function(newValue, oldValue) {
      if (typeof newValue == "string") {
        this.makeToast("success");
      }
    },
  }
}
</script>